import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface StakeholderApproval {
  id: string;
  project_id: string;
  company_id: string;
  user_id: string;
  approval_type: 'initial_project' | 'change_request';
  line_item_key: string;
  line_item_label: string;
  is_approved: boolean;
  approver_initials: string | null;
  approved_at: string | null;
  created_at: string;
  is_active: boolean;
  user_first_name?: string;
  user_last_name?: string;
  user_email?: string;
}

export interface ApprovalSummary {
  total_stakeholders: number;
  fully_approved_stakeholders: number;
  approvals: StakeholderApproval[];
}

export async function getProjectApprovals(
  projectId: string,
  token: string,
  approvalType: string = 'initial_project'
): Promise<ApprovalSummary> {
  const response = await axios.get(
    `${API_BASE_URL}/projects/${projectId}/approvals`,
    {
      params: { approval_type: approvalType },
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return response.data.data;
}

export async function getMyApprovals(
  projectId: string,
  token: string
): Promise<StakeholderApproval[]> {
  const response = await axios.get(
    `${API_BASE_URL}/projects/${projectId}/approvals/mine`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data;
}

export async function getMyPendingCount(
  token: string
): Promise<number> {
  const response = await axios.get(
    `${API_BASE_URL}/projects/approvals/pending-count`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data.pending_count;
}

export async function approveLineItem(
  projectId: string,
  approvalId: string,
  initials: string,
  token: string
): Promise<StakeholderApproval> {
  const response = await axios.post(
    `${API_BASE_URL}/projects/${projectId}/approvals/${approvalId}/approve`,
    { initials },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data;
}
